<template>
  <nav class="bg-white shadow-md">
    <div class="container mx-auto px-4">
      <div class="flex justify-between items-center py-4">
        <div class="flex items-center">
          <router-link to="/" class="text-2xl font-bold text-blue-600">
            PDF2DOCX
          </router-link>
        </div>
        
        <div class="flex items-center space-x-4">
          <template v-if="!authStore.isAuthenticated">
            <router-link to="/login" class="text-gray-700 hover:text-blue-600">
              登录
            </router-link>
            <router-link to="/register" class="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
              注册
            </router-link>
          </template>
          <template v-else>
            <span class="text-gray-700">你好，{{ authStore.user?.username }}</span>
            <router-link to="/profile" class="text-gray-700 hover:text-blue-600">
              个人中心
            </router-link>
            <button @click="logout" class="text-gray-700 hover:text-red-600">
              退出
            </button>
          </template>
        </div>

        
      </div>
    </div>
  </nav>
</template>

<script setup>
import { useAuthStore } from '../stores/auth';
import { useRouter } from 'vue-router';

const authStore = useAuthStore();
const router = useRouter();

const logout = () => {
  authStore.logout();
  router.push('/');
};
</script>